import React from "react";

export class PanelBody extends React.Component {
    render() {
        return (
            <div className={"panel-body"}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/panel/PanelBody.js